import React from 'react';
import { useLocation, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useApp } from '../../contexts/AppContext';
import Header from './Header';
import Footer from './Footer';
import Sidebar, { isSidebarRoute } from './Sidebar';
import CookieConsent from '../common/CookieConsent';
import config from '../../config/app.config';

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  transition: margin-left 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  
  @media (min-width: 1024px) {
    margin-left: ${props => {
      if (!props.$sidebarVisible || !props.$sidebarOpen) return '0';
      return props.$sidebarCollapsed ? '80px' : '300px';
    }};
  }
`;

const Layout = () => {
  const location = useLocation();
  const { auth, sidebarOpen, sidebarCollapsed } = useApp();

  const isAuthPage = [
    config.routes.public.login,
    config.routes.public.logout
  ].includes(location.pathname);

  const isSidebarVisible = auth.authenticated && isSidebarRoute(location.pathname);

  return (
    <div className="min-h-screen flex flex-col">
      <Sidebar />

      <ContentWrapper
        $sidebarVisible={isSidebarVisible}
        $sidebarOpen={sidebarOpen}
        $sidebarCollapsed={sidebarCollapsed}
      >
        {!isAuthPage && <Header />}
        
        <main className={`flex-1 ${isAuthPage ? 'flex items-center justify-center' : ''}`}>
          <div className="w-full h-full">
            <Outlet />
          </div>
        </main>
        
        {!isAuthPage && <Footer />}
      </ContentWrapper>

      {!auth.authenticated && !isAuthPage && <CookieConsent />}
    </div>
  );
};

export default Layout;
